import { useEffect } from 'react';
import { Link } from 'react-router-dom';

export default function About() {
  useEffect(() => {
    const original = document.title;
    document.title = 'SAKURA GROUP HOLDINGS APP';
    return () => {
      document.title = original;
    };
  }, []);

  return (
    <div className="max-w-(--container-xs) h-screen mx-auto flex flex-col bg-white pt-safe sm:rounded-md sm:border sm:pt-0">
      <div className="flex-1 overflow-y-auto overflow-x-hidden">
        <div className="px-5 py-8 pb-safe">
          <article className="space-y-8 text-stone-800">
            <header className="space-y-3">
              <h1 className="text-2xl font-bold">SAKURA GROUP HOLDINGS APP</h1>
              <p className="text-sm leading-relaxed text-stone-600">
                <strong>SAKURA GROUP HOLDINGS APP</strong> は、株式会社サクラグループHOLDINGS. の社内業務を支援するための業務専用 Web アプリケーションです。所属メンバー間の業務連絡・情報共有・業務記録の管理を目的として提供しています。
              </p>
            </header>

            <section className="space-y-4">
              <h2 className="text-lg font-semibold">アプリの構成</h2>
              <p className="text-sm leading-relaxed">
                本サービスは、利用対象ごとに以下の 2 つのアプリケーションに分かれています。
              </p>

              <div className="space-y-3">
                <div className="rounded-lg border border-stone-200 p-4">
                  <h3 className="text-base font-semibold">管理画面 (admin)</h3>
                  <dl className="mt-3 space-y-1.5 text-sm leading-relaxed">
                    <div className="flex gap-2">
                      <dt className="w-14 shrink-0 text-stone-500">対象</dt>
                      <dd>株式会社サクラグループHOLDINGS. の管理者</dd>
                    </div>
                    <div className="flex gap-2">
                      <dt className="w-14 shrink-0 text-stone-500">URL</dt>
                      <dd className="break-all">https://admin.sakura-grp-hd.co.jp</dd>
                    </div>
                  </dl>
                </div>

                <div className="rounded-lg border border-stone-200 p-4">
                  <h3 className="text-base font-semibold">ホステスアプリ (hostess)</h3>
                  <dl className="mt-3 space-y-1.5 text-sm leading-relaxed">
                    <div className="flex gap-2">
                      <dt className="w-14 shrink-0 text-stone-500">対象</dt>
                      <dd>サクラグループ所属ホステス</dd>
                    </div>
                    <div className="flex gap-2">
                      <dt className="w-14 shrink-0 text-stone-500">URL</dt>
                      <dd className="break-all">https://hostess.sakura-grp-hd.co.jp</dd>
                    </div>
                  </dl>
                </div>
              </div>
            </section>

            <section className="space-y-3">
              <h2 className="text-lg font-semibold">利用対象</h2>
              <p className="text-sm leading-relaxed">
                本サービスは、当社が事前に登録したユーザー（管理者および所属ホステス）のみが利用できます。一般の方向けのサービスではなく、自由登録はできません。
              </p>
            </section>

            <section className="space-y-3">
              <h2 className="text-lg font-semibold">Google アカウント情報の利用について</h2>
              <p className="text-sm leading-relaxed">
                両アプリへのサインインには Google アカウントによる認証を利用しています。Google から取得する情報は OAuth スコープ <code className="rounded bg-stone-100 px-1">openid</code> / <code className="rounded bg-stone-100 px-1">email</code> / <code className="rounded bg-stone-100 px-1">profile</code> の範囲に限り、ログイン認証および本人確認以外の目的には使用しません。第三者への販売も行いません。
              </p>
            </section>

            <section className="space-y-3">
              <h2 className="text-lg font-semibold">運営</h2>
              <ul className="space-y-1 text-sm leading-relaxed">
                <li>株式会社サクラグループHOLDINGS.</li>
                <li className="text-stone-600">〒812-0025 福岡県福岡市博多区店屋町4-16 土居ビル5階</li>
              </ul>
            </section>

            <nav className="border-t border-stone-200 pt-6 text-sm">
              <Link to="/privacy" className="text-stone-600 underline underline-offset-4 hover:text-stone-900">
                プライバシーポリシー →
              </Link>
            </nav>
          </article>
        </div>
      </div>
    </div>
  );
}
